import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./LoginForm.css";
import { Link, Navigate } from "react-router-dom";
import Logo from "../Images/secondary_logo.svg";
import mainLogo from "../Images/portal.png";
import Vector from "../Images/Vector (1).svg";

const LoginForm = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.catalyst && window.catalyst.auth) {
      const config = {
        css_url: "/app/embeddediframe.css",
        forgot_password_css_url: "/app/embedded_password_reset.css",
      };

      window.catalyst.auth.signIn("loginDiv", config);
    } else {
      console.error("Catalyst auth is not available.");
    }
  }, []);

  useEffect(() => {
    const fetchHealthCheck = async () => {
      try {
        const response = await fetch("/server/subscription/health-check");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.status) {
          sessionStorage.setItem("Server", data.status);
        }
      } catch (error) {
        console.error("Error fetching health check:", error);
      }
    };

    fetchHealthCheck();
  }, []);

  return (
    <div class="flex flex-row w-full justify-between h-screen  max-sm:w-[auto]">
      <div class="left-side bg-[#CAD7D6] w-[50%] h-auto flex justify-center items-end max-sm:hidden md:w-[50%] overflow-hidden">
        <img
          src={mainLogo}
          alt="Logo"
          className="w-[auto] bottom-0 h-[auto] max-w-full object-contain"
        />
      </div>

      <div className="login-form right-side w-[50%] max-sm:w-[auto] flex flex-col gap-[5px]  justify-center items-center xl:justify-center xl:items-center">
        <div class="flex justify-center  ml-[-20px]">
          <img src={Logo} alt="Logo" className="w-28 h-10" />
        </div>
        <div
          id="loginDiv"
          className="h-[60vh] rounded-[16px] shawdow-lg mt-[5px] max-sm:h-[60vh]"
        ></div>
        <p className="text-[#0E5C57] text-[14] font-regular  flex items-center justify-center mt-[-100px] lg:mt-[-20px] xl:mt-[-70px] max-sm:mt-[-20px]">
          Privacy Policy
        </p>
        <div>
        <img class="fixed bottom-0 text-[#0E5C57] left-[85%] max-sm:hidden" src={Vector} malt="Invoice Header"/>
      </div>
      </div>
      
    </div>
  );
};

export default LoginForm;
